export default __webpack_public_path__ + "static/Icon-piggy-bank-cba930d42d6d667fc89b6aff19721aae.svg";